<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <g fill="#34313F" fill-rule="nonzero">
      <path
        d="M33.638 36.267h8.038c2.286 0 3.734-1.257 3.734-3.277 0-1.904-1.448-3.276-3.734-3.276h-8.038c-.267 0-.495.229-.495.457v5.639c.038.266.228.457.495.457ZM33.638 49.257h8.305c2.552 0 4.076-1.295 4.076-3.58 0-1.982-1.448-3.582-4.076-3.582h-8.305c-.267 0-.495.229-.495.457v6.21c.038.305.228.495.495.495Z"
      />
      <path
        d="M63.048.152 39.276 23.848h3.886c6.057 0 9.638 3.81 9.638 7.962 0 3.276-2.21 5.676-4.571 6.742-.381.153-.381.686.038.838 2.743 1.067 4.685 3.924 4.685 7.277 0 4.723-3.162 8.495-9.295 8.495H26.82c-.267 0-.495-.229-.495-.457V36.762L.229 62.742c-.343.344-.115.953.38.953h62.743c.229 0 .42-.19.42-.419V.496c.114-.42-.42-.648-.724-.344Z"
      />
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'BigCommerceLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
